import 'vant/lib/index.css';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {Button,DropdownMenu,DropdownItem,Cell,Switch,Field} from 'vant'
import { RadioGroup, Radio } from 'vant';
import { CheckboxGroup, Checkbox } from 'vant';
import { Tab, Tabs } from 'vant';
import { Tabbar, TabbarItem } from 'vant';
import { NavBar, Icon, Tag } from 'vant';

import '@/assets/font.css';

import Antd from 'ant-design-vue';
Vue.use(Antd);

import EasySlider from "vue-easy-slider";

Vue.use(EasySlider);

import 'ant-design-vue/dist/antd.css'; // or 'ant-design-vue/dist/antd.less'

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import VueMarqueeSlider from 'vue-marquee-slider';
Vue.use(VueMarqueeSlider)


Vue.component('van-field', Field)
Vue.component('van-button', Button)
Vue.component('van-dropdown-menu', DropdownMenu)
Vue.component('van-dropdown-item', DropdownItem)
Vue.component('van-cell', Cell)
Vue.component('van-switch', Switch)
Vue.component('van-checkbox-group', CheckboxGroup)
Vue.component('van-checkbox', Checkbox)
Vue.component('van-radio-group', RadioGroup)
Vue.component('van-radio', Radio)
Vue.component('van-tab', Tab)
Vue.component('van-tabs', Tabs)
Vue.component('van-tabbar', Tabbar)
Vue.component('van-tabbar-item', TabbarItem)
Vue.component('van-nav-bar', NavBar)
Vue.component('van-icon', Icon)
Vue.component('van-tag', Tag)
Vue.config.productionTip = false

import zh from "./views/lanhu_fufuture2/local/zh";
import en from "./views/lanhu_fufuture2/local/en";
import ko from "./views/lanhu_fufuture2/local/kr";
import ja from "./views/lanhu_fufuture2/local/jp";
import zh_HK from "./views/lanhu_fufuture2/local/zh_HK";

const messages={
  zh,
  en,
  ko,
  ja,
  zh_HK
}

const i18n = new VueI18n({
  messages,
  locale: localStorage.getItem("lang")??"zh"
})



new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
